'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auditprogramdrgchanges = require('./auditprogramdrgchanges.html');

var _auditprogramdrgchanges2 = _interopRequireDefault(_auditprogramdrgchanges);

var _auditprogramdrgchanges3 = require('./auditprogramdrgchanges.controller');

var _auditprogramdrgchanges4 = _interopRequireDefault(_auditprogramdrgchanges3);

require('./auditprogramdrgchanges.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditprogramdrgchangesComponent = {
  restrict: 'E',
  bindings: {},
  template: _auditprogramdrgchanges2.default,
  controller: _auditprogramdrgchanges4.default,
  controllerAs: 'vm'
};

exports.default = auditprogramdrgchangesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramdrgchanges/auditprogramdrgchanges.component.js